import { IonSpinner } from "@ionic/react";
import { SessionView } from "admin/src/server/mappers/session/session";
import { surveyPreviewExpressions } from "admin/src/ui/components/surveyJS/preview/surveyPreviewExpressions";
import { GetForm, useApiQuery } from "api";
import LoadingPage from "components/common/LoadingPage";
import PageComponent from "components/common/PageComponent";
import useSession from "hooks/useSession";
import { Suspense, lazy } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { getSocietyId } from "utils/getSocietyId";
import { getProfileId } from "utils/sessionStorage/user";
import { ENV } from "../appConstants/env";

interface RouteParams {
  id: string;
}

const LazyLoadedSurveyPreview = lazy(() =>
  import("admin/src/ui/components/surveyJS/preview/SurveyPreview").then(
    (module) => ({
      default: module.SurveyPreview,
    }),
  ),
);

const FormPage = () => {
  const { id } = useParams<RouteParams>();
  const history = useHistory();
  const location = useLocation();
  const session = useSession();
  const searchQueryParams = new URLSearchParams(location.search);
  const instanceId = searchQueryParams.get("workflowInstanceId");

  const { data: getFormResponse, isLoading: getFormIsLoading } = useApiQuery(
    GetForm,
    { societyId: getSocietyId().toString(), formId: id },
    { profileId: getProfileId() },
  );

  const form = !getFormResponse?.data
    ? undefined
    : JSON.parse(JSON.stringify(getFormResponse?.data!.body!.formDesign));

  const responseData = JSON.parse(
    JSON.stringify(session.profile?.additionalInformation ?? {}),
  );
  const assignmentId = searchQueryParams.get("assignmentId");
  const uiMsg = searchQueryParams.get("message");

  if (getFormIsLoading) {
    return <LoadingPage />;
  }
  return (
    <PageComponent>
      <PageComponent.Header>Form</PageComponent.Header>
      <PageComponent.Content>
        {uiMsg && (
          <div className="flex justify-center p-2">
            <h4 className="font-medium w-max">{uiMsg}</h4>
          </div>
        )}
        {getFormResponse?.data && (
          <Suspense fallback={<LoadingPage />}>
            <LazyLoadedSurveyPreview
              baseUrl={ENV.REACT_APP_PILLAR_API_URL}
              additionalInfo={{
                profileId: getProfileId(),
                workflowInstanceId: Number(instanceId),
              }}
              profile={session.profile ?? undefined}
              formDesign={form}
              formData={responseData}
              formId={Number(id)}
              //FOR SEAN form data here? idk brain no work good
              assignmentId={Number(assignmentId)}
              afterWorkflowInstanceStopped={async () => {
                session.refreshSession();
                history.push(
                  `/workflow/new/${getFormResponse?.data?.body!.id}`,
                );
              }}
              session={session as SessionView}
              spinner={<IonSpinner />}
              {...surveyPreviewExpressions}
            />
          </Suspense>
        )}
      </PageComponent.Content>
    </PageComponent>
  );
};

export default FormPage;
